import React, { useEffect, useState } from "react";
import { ArrowsClockwise, X } from "@phosphor-icons/react";

const CHECK_MS = 5 * 60 * 1000;
const mainBundle = (html) => (html.match(/\/static\/js\/main\.[a-z0-9]+\.js/i) || [])[0] || null;

export function UpdateBanner() {
  const [ready, setReady] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const current = [...document.scripts].map((s) => s.src).map((src) => (src.match(/\/static\/js\/main\.[a-z0-9]+\.js/i) || [])[0]).find(Boolean);
    if (!current) return undefined; // dev server — bundles aren't fingerprinted
    let stop = false;
    const check = async () => {
      try {
        const res = await fetch(`/index.html?u=${Date.now()}`, { cache: "no-store" });
        const latest = mainBundle(await res.text());
        if (!stop && latest && latest !== current) setReady(true);
      } catch { /* offline — try again later */ }
    };
    const timer = setInterval(check, CHECK_MS);
    const onVisible = () => document.visibilityState === "visible" && check();
    document.addEventListener("visibilitychange", onVisible);
    const kick = setTimeout(check, 20 * 1000);
    return () => { stop = true; clearInterval(timer); clearTimeout(kick); document.removeEventListener("visibilitychange", onVisible); };
  }, []);

  const reload = async () => {
    try {
      const reg = await navigator.serviceWorker?.getRegistration();
      await reg?.update();
      reg?.waiting?.postMessage({ type: "SKIP_WAITING" });
    } catch { /* no SW */ }
    window.location.reload();
  };

  if (!ready || hidden) return null;
  return (
    <div className="fixed left-3 right-3 md:left-1/2 md:right-auto md:-translate-x-1/2 bottom-[calc(5rem+env(safe-area-inset-bottom))] md:bottom-5 z-[95] md:max-w-[calc(100vw-2rem)]" data-testid="update-banner">
      <div className="mfg-holo-panel !rounded-2xl md:!rounded-full pl-4 pr-2 py-2 flex flex-wrap items-center gap-2 md:gap-3 shadow-2xl">
        <span className="w-2 h-2 rounded-full bg-[#5EB0FF] animate-pulse" />
        <span className="text-xs font-bold flex-1 min-w-[10rem] leading-snug">Update available — a new version of MFG is ready</span>
        <button onClick={reload} data-testid="update-banner-reload" className="ml-auto px-3 py-1.5 rounded-full bg-[#0A84FF] text-white text-xs font-bold inline-flex items-center gap-1 hover:bg-[#3b9cff] shrink-0"><ArrowsClockwise size={12} weight="bold" /> Reload</button>
        <button onClick={() => setHidden(true)} data-testid="update-banner-dismiss" aria-label="Dismiss" className="p-1.5 rounded-full text-white/60 hover:text-white"><X size={12} weight="bold" /></button>
      </div>
    </div>
  );
}
